import {atom} from 'recoil'

export const stateOpenInfoBox = atom({
    key: "infobox",
    default: false
})
